export default "__VITE_ASSET__Blbu_x4T__"